Shopware.Component.register('riccardo-magazine-list', () => import('./page/riccardo-magazine-list'));
Shopware.Component.register('riccardo-magazine-detail', () => import('./page/riccardo-magazine-detail'));

Shopware.Module.register('riccardo-magazine', {
    type: 'plugin',
    name: 'riccardo-magazine',
    title: 'Magazin',
    description: 'Beiträge des Riccardo Magazins',
    color: '#E30613',
    icon: 'regular-content',
    entity: 'riccardo_magazine_post',

    routes: {
        list: { component: 'riccardo-magazine-list', path: 'list' },
        detail: { component: 'riccardo-magazine-detail', path: 'detail/:id', meta: { parentPath: 'riccardo.magazine.list' }, props: { default: (route) => ({ postId: route.params.id }) } },
        create: { component: 'riccardo-magazine-detail', path: 'create' },
    },

    navigation: [{
        id: 'riccardo-magazine',
        label: 'Magazin',
        color: '#E30613',
        path: 'riccardo.magazine.list',
        icon: 'regular-content',
        parent: 'sw-content',
        position: 85,
    }],
});
